import { ROUTES } from '@app/router/constants';

import { TabConfig, UserType } from './types';

export const TAB_CONFIG: TabConfig = {
  // Default tabs for most users
  [UserType.Default]: [
    { path: ROUTES.HOME, testId: 'Overview' },
    { path: ROUTES.BILLING, testId: 'PayBill' },
    { path: ROUTES.PLAN, testId: 'PlanUsage' },
  ],

  // Fixed wireless users have limited tabs
  [UserType.FixedWireless]: [
    { path: ROUTES.HOME, testId: 'Overview' },
    { path: ROUTES.BILLING, testId: 'PayBill' },
  ],

  // Fiber users have limited tabs (no Usage)
  [UserType.Fiber]: [
    { path: ROUTES.HOME, testId: 'Overview' },
    { path: ROUTES.BILLING, testId: 'PayBill' },
  ],
};
